/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DeviceStatusCount
 */
export interface DeviceStatusCount {
    /**
     * JETCharge: for all devices in the system.
     * DNSPsProject: For all devices in the Jemena project.
     * Else one of DnspAccessTags enums
     * @type {string}
     * @memberof DeviceStatusCount
     */
    group?: string;
    /**
     * offline, or unique values from Device.Status column
     * @type {string}
     * @memberof DeviceStatusCount
     */
    status?: string;
    /**
     * The count of devices in this group, with this status
     * @type {number}
     * @memberof DeviceStatusCount
     */
    count?: number;
}

/**
 * Check if a given object implements the DeviceStatusCount interface.
 */
export function instanceOfDeviceStatusCount(
    value: object,
): value is DeviceStatusCount {
    return true;
}

export function DeviceStatusCountFromJSON(json: any): DeviceStatusCount {
    return DeviceStatusCountFromJSONTyped(json, false);
}

export function DeviceStatusCountFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceStatusCount {
    if (json == null) {
        return json;
    }
    return {
        group: json["group"] == null ? undefined : json["group"],
        status: json["status"] == null ? undefined : json["status"],
        count: json["count"] == null ? undefined : json["count"],
    };
}

export function DeviceStatusCountToJSON(value?: DeviceStatusCount | null): any {
    if (value == null) {
        return value;
    }
    return {
        group: value["group"],
        status: value["status"],
        count: value["count"],
    };
}
